import {Provider} from '@angular/core';
import {TEST_MODULE_REGISTRY, TestModuleDefinition} from '../../../core/shared/test/data/test-harness.types';
import {
    SmSigningProcessOverviewPage
} from '../page/overview/sm-signing-process-overview/sm-signing-process-overview.page';
import {SmSigningProcessObjectPage} from '../page/object/sm-signing-process-object/sm-signing-process-object.page';
import {SmSigningPlaygroundPage} from '../page/sm-signing-playground/sm-signing-playground.page';
import {
    SmSigningProcessObjectComponent
} from '../component/object-components/sm-signing-process-object/sm-signing-process-object.component';

const smModuleEntry: TestModuleDefinition = {
    key: 'sm',
    label: 'Signature (sm)',
    components: [
        {
            key: 'SmSigningProcessOverviewPage',
            component: SmSigningProcessOverviewPage,
            selector: 'mvs-sm-signing-process-overview-page',
            type: 'PageComponent',
            label: 'signing process overview page'
        },
        {
            key: 'SmSigningProcessObjectPage',
            component: SmSigningProcessObjectPage,
            selector: 'mvs-sm-signing-process-object-page',
            type: 'PageComponent',
            label: 'signing process object page'
        },
        {
            key: 'SmSigningPlaygroundPage',
            component: SmSigningPlaygroundPage,
            selector: 'mvs-sm-signing-playground-page',
            type: 'PageComponent',
            label: 'signing playground page'
        },
        {
            key: 'SmSigningProcessObjectComponent',
            component: SmSigningProcessObjectComponent,
            selector: 'mvs-sm-signing-process-object',
            type: 'ObjectComponent',
            label: 'signing process object component'
        },
    ]
}

export const SM_TEST_PROVIDERS: Provider[] = [
    {provide: TEST_MODULE_REGISTRY, useValue: smModuleEntry, multi: true}
];
